module.exports = "<app-sidenav></app-sidenav>\n"